<template>
      <TsSection>
    <TsCardOpinionProduct :banner-image="props.backgroundImage">
      <template #front>
        <TsCard append-class="max-w-[818px] mx-auto">
           <TsTypography as="h2" >{{  props.title }}</TsTypography>
          <TsDivider/>
          <TsTypography>{{ props.description }}</TsTypography>
          <TsRow>
           <TsColumn> <TsButton block label="Learn more"/></TsColumn>
           <TsColumn> <TsButton outlined block label="Watch now"/></TsColumn>
          </TsRow>
        </TsCard>
      </template>
    </TsCardOpinionProduct>
  </TsSection>
</template>

<script setup lang="ts">

const TsCardOpinionProduct = defineAsyncComponent(
    () => import('~/components/organisms/TsCardOpinionProduct.vue')
);

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);





type Props = {
    backgroundImage: string;
    title: string;
    description: string;
}

const props = withDefaults(defineProps<Props>(), {
    backgroundImage: '/images/dewaltBanner.webp',
    title: 'A NAME THAT MEANS SOMETHING',
    description: 'When we put the DEWALT® name on something, it’s a commitment to get the job done right. It’s the mark we’ve left over 100 years of helping world-builders build the modern world.'
});
</script>